import {CollectionImageStack} from './CollectionCard';
import {CollectionCreateButton} from './CollectionCreateButton';

export const EmptyCollectionsCard = () => {
  return (
    <div className="size-full rounded-lg border bg-bg-secondary p-20">
      <div className="mx-auto flex size-full max-w-sm flex-col items-start justify-center gap-8">
        <div className="flex flex-col gap-2">
          <div className="h-[200px] w-[300px]">
            <CollectionImageStack imgStep={null} />
          </div>
          <div className="mx-2 h-5 w-2/3 shrink-0 rounded-md border bg-border-primary px-2" />
          <div className="mx-2 h-4 w-1/3 shrink-0 rounded-md border bg-border-primary px-2" />
        </div>
        <div>
          <h1 className="mb-3 text-title-h1">Коллекции</h1>
          <p className="max-w-sm text-paragraph-lg text-text-secondary">
            Соберите подборку своих инструкций, добавьте описание и поделитесь ей с&nbsp;клиентом
            или коллегой.
          </p>
        </div>
        <CollectionCreateButton />
      </div>
    </div>
  );
};
